// Reusable color variables (canonical palette — JS source of truth)
export const pink = '#ff69b4';
export const red = '#eb361d';
export const orange = '#e18d3d';
export const yellow = '#eed75a';
export const green = '#297d0a';
export const blue = '#0098DA';
export const purple = '#6f337b';
export const brown = '#a54c2a';
export const black = '#000000';
export const white = '#ffffff';
export const blueGray = '#405866'; // == $npGray
export const gray = '#757575';
export const lightGray = '#eee';
export const navy = '#2c3e50'; // == $darkNavy; used as on-surface text
export const linkBlue = '#009ddc'; // == $linkBlue (distinct from `blue`)

// Shared overlay color-picker palette for polygon/polyline and access route overlays.
export const overlayColorPalette = [
  pink, red, orange, yellow, green, blue, purple, brown, black, gray,
  '#ff2d95', '#ff1a1a', '#ff8c00', '#ffe600', '#3ddc97', '#00c2ff', '#a600ff', '#c1440e', '#1b1f24', '#bdbdbd',
  '#ff6f61', '#ff3b3b', '#ffa62b', '#f4d03f', '#8bc34a', '#3d8fc4', '#9b4d96', '#e2984c', '#332b25', '#948c7f',
  '#ffb6c1', '#ff6961', '#ffcc80', '#fff9c4', '#90ee90', '#87ceeb', '#d8bfd8', '#c8a27a', '#6e6b67', '#e0e0e0',
  '#c0246e', '#a81a1a', '#a84a00', '#b8930a', '#1f5c2b', '#0d4d78', '#4a1d78', '#704423', '#232323', '#474747',
];
